<template>
  <div class="business-online">
    <website-header :setNum="1"></website-header>
    <div class="index-top display-flex justify-content-center align-items-center" :style="`background-image:url('${imgURI + '/static/business/online/BJ4.png'}');`">
      <div class="index-top-msg display-flex justify-content-center align-items-center">
        <div>
          <div class="title bold">ONLINE</div>
          <div class="tips">RESOURCE ADVANTAGES</div>
          <div class="line"></div>
          <div class="tips2">线上资源优势</div>
        </div>
        <img class="index-top-img" :src="`${imgURI}/static/business/online/TX.png`"/>
      </div>
    </div>
    <div class="kuang-img display-flex justify-content-center">
      <img :src="`${imgURI}/static/business/online/kuang.png`"/>
    </div>
    <div class="def-width margin-center">
      <div class="online-nav">微信公域+私域</div>
    </div>
    <div class="display-flex justify-content-center">
      <img :src="`${imgURI}/static/business/online/T1.png`"/>
      <div class="content1 display-flex justify-content-center align-items-center">
        <div>主号：侃侃跨境那些事儿</div>
        <div>Moss的精神家园</div>
        <div>共计200+社群</div>
        <div>60W优质亚马逊卖家聚集媒体</div>
        <div>账号+社群全网覆盖用户触达2000W+</div>
      </div>
    </div>
    <div class="def-width margin-center">
      <div class="online-nav">跨境大V-Moss</div>
    </div>
    <div class="display-flex justify-content-center">
      <div class="content1 display-flex justify-content-center align-items-center">
        <div>全网粉丝50W+</div>
        <div>账户垂直度精准，流量粘性高</div>
        <div>认可度高，品牌信任价值传递高</div>
      </div>
      <img :src="`${imgURI}/static/business/online/T2.png`"/>
    </div>
    <div class="def-width margin-center">
      <div class="online-nav">媒体矩阵</div>
    </div>
    <div class="display-flex justify-content-center" style="margin-bottom: 127px">
      <img :src="`${imgURI}/static/business/online/T3.png`"/>
      <div class="content1 display-flex justify-content-center align-items-center text-center">
        <div>覆盖：抖音、小红书、B站、头条号、知乎、微博</div>
        <div style="line-height: 30px">覆盖全网流量大的平台<br/>
          图文+短视频+直播打造最专业的跨境自媒体团队</div>
      </div>
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import config from '@/config/index'
export default {
  name: "businessOnline",
  components: {WebsiteBot, WebsiteHeader},
  data () {
    return {
      imgURI: config.imgURI
    }
  }
}
</script>

<style lang="scss" scoped>
.business-online{
  .index-top{
    margin-top: 100px;
    width: 100%;
    height: 650px;
    background-image: url("/static/business/online/BJ4.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .index-top-msg{
      color: #FFFFFF;
      .title{
        font-size: 90px;
      }
      .tips{
        position: relative;
        z-index: 3;
        margin-right: -12px;
        font-size: 48px;
        font-weight: lighter;
      }
      .line{
        margin: 38px 0;
        width: 190px;
        border: 1px solid #386BF3;
      }
      .index-top-img{
        position: relative;
        z-index: 2;
        width: 675px;
        height: 450px;
      }
      .tips2{
        font-size: 40px;
      }
    }
  }
  .kuang-img{
    z-index: 3;
    position: absolute;
    top: 420px;
    left: 36%;
  }
  .online-nav{
    margin: 112px 0 84px 0;
    padding-left: 24px;
    border-left: 4px solid #386BF3;
    letter-spacing: 4px;
    font-size: 40px;
  }
  .content1{
    width: 460px;
    height: 432px;
    background-image: url("/static/business/online/obg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    flex-direction: column;
    line-height: 50px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business/online.vue